import useSession from '../hooks/useSession';
import { createContainer } from 'unstated-next';
import { useState } from 'react';

const useGlobalStore = () => {
  const { session, storeSession, signOut, status } = useSession();
  const [menuOpen, setMenuOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [affID, setAffID] = useState('');

  return {
    session,
    storeSession,
    signOut,
    status,
    menuOpen,
    setMenuOpen,
    loading,
    setLoading,
    affID,
    setAffID
  };
};

const GlobalStore = createContainer(useGlobalStore);
export default GlobalStore;
